module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_X",
      "title": "X"
    }
  }, [_c('section', {
    staticClass: "exergues",
    attrs: {
      "epub:type": "epigraph"
    }
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-00X"
    }
  }, [_c('i', [_vm._v("I have set you an example, that you should do as I have done to you. Very truly, I tell you, servants are not greater than their master, nor are messengers greater than the one who sent them. If you know these things, you are blessed if you do them.")])])]), _c('div', {
    staticClass: "exer_source"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-00X"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 13:15-17")])])])]), _c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-00X"
    }
  }, [_c('i', [_vm._v("Everyone then who hears these words of mine and acts on them will be like a wise man who built his house on rock. The rain fell, the floods came, and the winds blew and beat on that house, but it did not fall, because it had been founded on rock.")])])]), _c('div', {
    staticClass: "exer_source"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-00X"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTHEW 7:24-25")])])])]), _c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-00X"
    }
  }, [_c('i', [_vm._v("Brothers and sisters, join in imitating me, and observe those who live according to the example you have in us.")])])]), _c('div', {
    staticClass: "exer_source"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-00X"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIPPIANS 3:17")])])])]), _c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-00X"
    }
  }, [_c('i', [_vm._v("For, while physical training is of some value, godliness is valuable in every way, holding promise for both the present life and the life to come.")])])]), _c('div', {
    staticClass: "exer_source"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-00X"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("1")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMOTHY 4:8")])])])]), _c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-00X"
    }
  }, [_c('i', [_vm._v("Perhaps, then, the memory of anyone distinguished in life would be enough to fill our need for a beacon light and to show us how we can bring our soul to the sheltered harbor of virtue where it no longer has to pass the winter amid the storms of life or be shipwrecked in the deep water of evil by the successive billows of passion. It may be for this very reason that the daily life of those sublime individuals is recorded in detail, that by imitating those earlier examples of right action those who follow them may conduct their lives to the good.")])])]), _c('div', {
    staticClass: "exer_source"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-00X"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSSA")]), _vm._v(", "), _c('i', [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("HE ")])]), _c('i', [_vm._v("L")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("IFE OF ")])]), _c('i', [_vm._v("M")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("OSES")])])]), _c('span', {
    staticClass: "small"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-001",
      "id": "ap_ntf-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "bl"
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0